import { useState, type FormEvent } from 'react';
import { Button, Form, InlineNotification, PasswordInput, Stack, TextInput } from '@carbon/react';
import { ArrowRight } from '@carbon/icons-react';
import { useAuth } from '../auth/AuthContext';
import { InlineError } from '../components/states';
import logo from '../assets/ruby-logo.webp';

export function LoginPage() {
  const { login, notice } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<unknown>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(username.trim(), password);
    } catch (x) {
      setError(x);
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="login">
      <section className="login__hero">
        <img className="login__logo" src={logo} alt="Ruby.club" width={400} height={323} />
        <p className="login__tagline">Trang quản trị nội bộ</p>
      </section>
      <section className="login__panel">
        <div className="login__card">
          <h1>Đăng nhập</h1>
          <p className="login__sub">Dành cho chủ sở hữu và nhân viên vận hành.</p>
          <Form onSubmit={submit} aria-label="Đăng nhập quản trị">
            <Stack gap={6}>
              {notice && <InlineNotification kind="warning" lowContrast hideCloseButton role="alert" title={notice} />}
              <TextInput id="u" labelText="Tên đăng nhập" autoComplete="username" value={username} onChange={(e) => setUsername(e.target.value)} required />
              <PasswordInput showPasswordLabel="Hiện mật khẩu" hidePasswordLabel="Ẩn mật khẩu" id="p" labelText="Mật khẩu" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
              <InlineError error={error} />
              <Button type="submit" renderIcon={ArrowRight} disabled={busy || !username || !password}>
                {busy ? 'Đang kiểm tra' : 'Đăng nhập'}
              </Button>
            </Stack>
          </Form>
        </div>
      </section>
    </main>
  );
}
